import * as DocumentPicker from "expo-document-picker";
import { DocumentPickerAsset } from "expo-document-picker";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Text, Pressable, View, ActivityIndicator } from "react-native";
import Toast from "react-native-toast-message";

interface ButtonUploadProps {
  label: string;
  onClick: (
    file: DocumentPickerAsset,
    item?: string,
    individualId?: string
  ) => void;
  item?: string;
  individualId?: string;
  size?: number;
  sizeMessage?: string;
  onlyImage?: boolean;
  onlyPdf?: boolean;
  isLoading?: boolean;
}

export default function ButtonUploadDoc(props: ButtonUploadProps) {
  const [isPressed, setIsPressed] = useState(false);
  const { t } = useTranslation();
  const allFileTypes = ["application/pdf", "image/jpeg", "image/png"];
  const imageType = ["image/jpeg", "image/png"];
  const pdfType = ["application/pdf"];

  const pickDocument = async () => {
    const result = await DocumentPicker.getDocumentAsync({
      type: props.onlyImage
        ? imageType
        : props.onlyPdf
          ? pdfType
          : allFileTypes,
      copyToCacheDirectory: false,
      multiple: false,
    });
    if (!result.canceled && result.assets && result.assets.length === 1) {
      if (props.size && result.assets[0].size > props.size) {
        Toast.show({
          type: "info",
          visibilityTime: 5000,
          props: {
            text1: t("common:toast.warning"),
            text2: props.sizeMessage,
          },
        });
      } else {
        if (props.individualId) {
          props.onClick(result.assets[0], props.item, props.individualId);
        } else {
          props.onClick(result.assets[0], props.item);
        }
      }
    }
  };

  return (
    <View className="w-40 h-9 items-center justify-center">
      {props.isLoading ? (
        <ActivityIndicator size="large" color="#5D0CBA" />
      ) : (
        <Pressable
          className={`transition-colors delay-100 bg-purple1 hover:bg-purple3 items-center justify-center w-40 h-9 rounded ${
            isPressed && "bg-purple5"
          }`}
          onPress={pickDocument}
          onPressIn={() => setIsPressed(true)}
          onPressOut={() => setIsPressed(false)}
        >
          <Text className="text-white text-center">{props.label}</Text>
        </Pressable>
      )}
    </View>
  );
}
